import LegalLayout from './LegalLayout.jsx';

export default function AgbPage() {
  return (
    <LegalLayout title="Allgemeine Geschäftsbedingungen" meta="Stand: 23. Oktober 2026 · tresor.datenputzer.de">
      <section className="legal-section">
        <p>
          <strong>Für wen diese Fassung gilt:</strong> für einzeln gebuchte Tresor-Tarife. Ist der Tresor in
          Ihrem Tarif Tiefenreinigung enthalten, gelten die{' '}
          <a href="https://datenputzer.de/agb#tresor">AGB von datenputzer.de</a>.
        </p>
      </section>
      <section className="legal-section">
        <h2>§ 1 Geltungsbereich</h2>
        <p>
          (1) Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge über die Nutzung des
          verschlüsselten Cloudspeichers <strong>Datenputzer Tresor</strong> unter{' '}
          <strong>tresor.datenputzer.de</strong> (nachfolgend „Dienst“) zwischen Kevin Pabst IT-Dienstleistungen,
          handelnd unter „Datenputzer“ (nachfolgend „Anbieter“), und dem Nutzer.
        </p>
        <p>
          (2) Das Angebot richtet sich an Verbraucher und Unternehmer. Abweichende Bedingungen des Nutzers
          werden nicht anerkannt, es sei denn, der Anbieter stimmt ihrer Geltung ausdrücklich schriftlich zu.
        </p>
        <p>
          (3) Impressum und Kontaktdaten des Anbieters:{' '}
          <a href="https://datenputzer.de/impressum.html" className="ed-link">datenputzer.de/impressum</a>.
        </p>
      </section>

      <section className="legal-section">
        <h2>§ 2 Vertragsgegenstand</h2>
        <p>
          (1) Der Anbieter stellt dem Nutzer Speicherplatz in einem Zero-Knowledge-Cloudspeicher zur Verfügung.
          Dateiinhalte und Dateinamen werden im Browser des Nutzers verschlüsselt, bevor sie auf die Server des
          Anbieters übertragen werden.
        </p>
        <p>
          (2) Der Funktionsumfang und das gebuchte Speichervolumen ergeben sich aus dem zum Zeitpunkt des
          Vertragsschlusses gewählten Tarif auf der Startseite von tresor.datenputzer.de.
        </p>
        <p>
          (3) Der technische Ablauf der Verschlüsselung ist unter{' '}
          <a href="/docs" className="ed-link">/docs</a> dokumentiert. Der Anbieter schuldet die Bereitstellung
          des Dienstes, nicht die erfolgreiche Wiederherstellung von Daten bei Verlust der Zugangsdaten durch den Nutzer
          (siehe § 4).
        </p>
      </section>

      <section className="legal-section">
        <h2>§ 3 Vertragsschluss und Kontoaktivierung</h2>
        <p>
          (1) Der Vertrag kommt zustande, wenn der Nutzer den Buchungsprozess über{' '}
          <strong>datenputzer.de/cloud-checkout</strong> oder die Buchungsfunktion unter{' '}
          <strong>tresor.datenputzer.de</strong> bzw. im Datenputzer-Konto abschließt und die Zahlung erfolgreich
          verarbeitet wurde.
        </p>
        <p>
          (2) Voraussetzung ist ein bestehendes oder neu angelegtes Datenputzer-Konto. Nach erfolgreicher Buchung
          wird der Tresor dem Konto zugeordnet und kann unter tresor.datenputzer.de eingerichtet werden.
        </p>
        <p>
          (3) Diese AGB und die{' '}
          <a href="/datenschutz" className="ed-link">Datenschutzerklärung</a> für den Tresor werden dem Nutzer vor der
          Buchung angezeigt. Mit seiner Bestätigung im Buchungsfenster werden sie Vertragsbestandteil. Der Nutzer kann
          sie jederzeit unter tresor.datenputzer.de/agb abrufen, speichern und ausdrucken.
        </p>
        <p>
          (4) Technische Schritte: Der Nutzer wählt Tarif und Abrechnungszeitraum, prüft die Zusammenfassung mit Preis
          und Laufzeit und kann seine Eingaben dort korrigieren. Mit dem Klick auf „Zahlungspflichtig buchen“ gibt er
          ein verbindliches Angebot ab. Der Anbieter nimmt es durch die Buchungsbestätigung per E-Mail an und speichert
          den Vertragstext. Vertragssprache ist Deutsch.
        </p>
      </section>

      <section className="legal-section">
        <h2>§ 4 Zero-Knowledge, Passwort und Recovery-Phrase</h2>
        <p>
          (1) Der Dienst arbeitet nach dem Zero-Knowledge-Prinzip: Der Anbieter erhält und speichert das
          Tresor-Passwort des Nutzers nicht und kann verschlüsselte Dateiinhalte nicht einsehen.
        </p>
        <p>
          (2) Es gibt <strong>keinen klassischen Passwort-Reset per E-Mail</strong>. Bei Verlust des Passworts kann
          der Zugang nur mit der bei der Einrichtung angezeigten <strong>Recovery-Phrase</strong> (12-Wörter-Notfallschlüssel)
          wiederhergestellt werden.
        </p>
        <p>
          (3) Gehen Passwort und Recovery-Phrase unwiderruflich verloren, sind die gespeicherten Daten dauerhaft
          nicht wiederherstellbar. Der Nutzer ist verpflichtet, die Recovery-Phrase sicher und getrennt vom Passwort
          aufzubewahren.
        </p>
      </section>

      <section className="legal-section">
        <h2>§ 5 Pflichten des Nutzers, Hinweise auf rechtswidrige Inhalte</h2>
        <p>
          (1) Der Nutzer nutzt den Dienst nur im Rahmen geltenden Rechts und dieser AGB.
        </p>
        <p>
          (2) Untersagt ist insbesondere die Nutzung als öffentliche Filesharing-Plattform, die Verbreitung
          rechtswidriger Inhalte sowie jede Form von Missbrauch, die die Infrastruktur oder andere Nutzer
          beeinträchtigt.
        </p>
        <p>
          (3) Der Nutzer ist für regelmäßige Sicherungskopien wichtiger Daten selbst verantwortlich. Aufgrund des
          Zero-Knowledge-Modells kann der Anbieter bei Datenverlust auf Nutzerseite keine Inhalte rekonstruieren.
        </p>
        <p>
          (4) Zugangsdaten und Recovery-Phrase dürfen nicht an unbefugte Dritte weitergegeben werden.
        </p>
        <p>
          (5) Hinweise auf rechtswidrige Inhalte nimmt der Anbieter unter{' '}
          <a href="mailto:abuse@datenputzer.de" className="ed-link">abuse@datenputzer.de</a> entgegen (Art. 16 DSA).
          Weil Dateiinhalte und Dateinamen verschlüsselt sind, kann der Anbieter Inhalte nicht einsehen. Er prüft
          Hinweise anhand der mitgeteilten Umstände, etwa wenn Zugangsdaten zu einem Tresor öffentlich verbreitet
          werden. Sperrt oder beendet der Anbieter einen Zugang, teilt er dem Nutzer die Gründe mit (Art. 17 DSA).
          Der Nutzer kann dem per E-Mail an support@datenputzer.de widersprechen. Der Anbieter prüft den Fall dann
          erneut.
        </p>
      </section>

      <section className="legal-section">
        <h2>§ 6 Preise und Zahlung</h2>
        <p>
          (1) Die Preise ergeben sich aus der jeweils auf tresor.datenputzer.de ausgewiesenen Preisliste
          (monatliche oder jährliche Abrechnung je nach Wahl im Checkout).
        </p>
        <p>
          (2) Die Abrechnung erfolgt über das beim Datenputzer-Konto hinterlegte Zahlungsmittel (z. B. Stripe)
          oder per Bitcoin über das Lightning-Netzwerk. Der Anbieter wendet die Kleinunternehmerregelung gemäß
          § 19 UStG an. Es wird keine Umsatzsteuer ausgewiesen.
        </p>
        <p>
          (3) Speichererweiterungen (Upgrades) werden für die laufende Abrechnungsperiode anteilig berechnet. Ab der
          nächsten Periode gilt der Preis des neuen Tarifs. Speicher-Downgrades werden nicht angeboten.
        </p>
        <p>
          (4) Nutzer mit einem bestehenden, aktiven <strong>Datenputzer-Schutz-Abo</strong>, die den Tresor als
          Zusatzleistung buchen, werden über die für das Schutz-Abo bereits hinterlegte Zahlungsmethode abgerechnet.
          Die Laufzeit des Tresor-Zusatzes entspricht der Abrechnungsperiode des Schutz-Abos. Der anteilige Betrag
          für die laufende Periode wird bei der Buchung fällig. Den genauen Betrag und den Folgepreis zeigt das
          Buchungsfenster vor der Bestätigung an.
        </p>
        <p>
          (5) Bei Zahlung über das Lightning-Netzwerk wird der gewählte Zeitraum im Voraus bezahlt. Eine
          automatische Verlängerung findet dabei nicht statt. Der Vertrag endet mit Ablauf des bezahlten Zeitraums,
          wenn der Nutzer nicht erneut bezahlt.
        </p>
      </section>

      <section className="legal-section">
        <h2>§ 7 Laufzeit und Kündigung</h2>
        <p>
          (1) Monatsabonnements laufen auf unbestimmte Zeit und können jederzeit zum Ende des laufenden
          Abrechnungsmonats gekündigt werden. Jahresabonnements haben eine Laufzeit von zwölf Monaten und können
          jederzeit zum Ende der Laufzeit gekündigt werden. Ohne Kündigung verlängern sie sich auf unbestimmte Zeit
          und können danach jederzeit mit einer Frist von einem Monat gekündigt werden. Für die Zeit nach dem
          Vertragsende bereits gezahlte Beträge erstattet der Anbieter anteilig.
        </p>
        <p>
          (2) Die Kündigung ist über das Datenputzer-Konto, über die Schaltfläche „Verträge hier kündigen“ am Ende
          jeder Seite oder per E-Mail an{' '}
          <a href="mailto:support@datenputzer.de" className="ed-link">support@datenputzer.de</a> möglich.
        </p>
        <p>
          (3) Mit dem Vertragsende endet der Zugang zum Tresor. Die verschlüsselten Dateien bewahrt der Anbieter
          danach 30 Tage auf, damit der Nutzer den Tresor erneut buchen und seine Dateien weiter nutzen kann. Danach
          werden sie endgültig gelöscht. Gesetzliche Aufbewahrungspflichten für Rechnungsdaten bleiben unberührt.
        </p>
        <p>
          (4) Das Recht zur außerordentlichen Kündigung aus wichtigem Grund bleibt unberührt.
        </p>
      </section>

      <section className="legal-section">
        <h2>§ 8 Verfügbarkeit und Infrastruktur</h2>
        <p>
          (1) Der Anbieter bemüht sich um eine hohe Verfügbarkeit des Dienstes. Geplante Wartungsarbeiten werden nach
          Möglichkeit vorab angekündigt. Kurzzeitige Störungen, höhere Gewalt oder Störungen bei Drittanbietern
          können die Erreichbarkeit vorübergehend einschränken.
        </p>
        <p>
          (2) Der Dienst wird über Infrastruktur in Deutschland betrieben. Verschlüsselte Dateiinhalte werden
          in <strong>Hetzner Object Storage</strong> (Hetzner Online GmbH, Deutschland) gespeichert. Der Anbieter
          schuldet die Bereitstellung des Speicherdienstes im Rahmen des gewählten Tarifs, nicht die Verfügbarkeit
          einzelner Drittanbieter-Komponenten über den gesetzlichen Rahmen hinaus.
        </p>
      </section>

      <section className="legal-section">
        <h2>§ 9 Haftung</h2>
        <p>
          (1) Der Anbieter haftet unbeschränkt für Schäden aus der Verletzung des Lebens, des Körpers oder der
          Gesundheit, bei Vorsatz und grober Fahrlässigkeit, bei arglistigem Verschweigen eines Mangels, bei
          Übernahme einer Garantie sowie nach dem Produkthaftungsgesetz.
        </p>
        <p>
          (2) Bei leicht fahrlässiger Verletzung einer wesentlichen Vertragspflicht haftet der Anbieter begrenzt auf
          den vertragstypischen, vorhersehbaren Schaden. Wesentliche Vertragspflichten sind Pflichten, deren Erfüllung
          die ordnungsgemäße Durchführung des Vertrags erst ermöglicht und auf deren Einhaltung der Nutzer regelmäßig
          vertrauen darf, hier insbesondere die Bereitstellung des Speicherplatzes und die Verschlüsselung im
          Browser. Im Übrigen ist die Haftung für leichte Fahrlässigkeit ausgeschlossen.
        </p>
        <p>
          (3) In den Fällen des Absatzes 2 ist die Haftung für Datenverlust auf den Aufwand begrenzt, der bei
          ordnungsgemäßer Datensicherung durch den Nutzer zur Wiederherstellung erforderlich gewesen wäre.
        </p>
        <p>
          (4) Diese Regelungen gelten auch für die Haftung der gesetzlichen Vertreter und Erfüllungsgehilfen des
          Anbieters.
        </p>
      </section>

      <section className="legal-section">
        <h2>§ 10 Datenschutz und Auftragsverarbeitung</h2>
        <p>
          Die Verarbeitung personenbezogener Daten im Zusammenhang mit dem Tresor ist in der{' '}
          <a href="/datenschutz" className="ed-link">Datenschutzerklärung für tresor.datenputzer.de</a> beschrieben.
          Unternehmern wird auf Anfrage ein Auftragsverarbeitungsvertrag (AVV) gemäß Art. 28 DSGVO zur Verfügung gestellt.
        </p>
      </section>

      <section className="legal-section" id="widerruf">
        <h2>§ 11 Widerrufsrecht für Verbraucher</h2>
        <p>
          (1) Verbrauchern steht ein gesetzliches Widerrufsrecht von 14 Tagen ab Vertragsschluss zu. Einzelheiten,
          die Folgen des Widerrufs und das Muster-Widerrufsformular stehen in der{' '}
          <a href="https://datenputzer.de/widerrufsbelehrung" className="ed-link">Widerrufsbelehrung</a>.
        </p>
        <p>
          (2) Der Nutzer kann den Widerruf online unter{' '}
          <a href="https://datenputzer.de/widerruf" className="ed-link">datenputzer.de/widerruf</a> erklären.
          Ebenso genügt eine eindeutige Erklärung per E-Mail an{' '}
          <a href="mailto:support@datenputzer.de" className="ed-link">support@datenputzer.de</a> oder per Post an die
          im Impressum genannte Anschrift. Bei Zahlung mit Bitcoin (Lightning) erfolgt der Widerruf per E-Mail.
        </p>
      </section>

      <section className="legal-section">
        <h2>§ 12 Schlussbestimmungen</h2>
        <p>
          (1) Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts. Bei Verbrauchern
          gilt diese Rechtswahl nur, soweit dadurch nicht der Schutz zwingender Bestimmungen des Rechts des Staates
          entzogen wird, in dem der Verbraucher seinen gewöhnlichen Aufenthalt hat.
        </p>
        <p>
          (2) Ist der Nutzer Kaufmann, juristische Person des öffentlichen Rechts oder öffentlich-rechtliches
          Sondervermögen, ist Gerichtsstand der Sitz des Anbieters.
        </p>
        <p>
          (3) Sollten einzelne Bestimmungen unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.
        </p>
      </section>
    </LegalLayout>
  );
}
